export default "__VITE_ASSET__7d7bf4b4__"